<div *ngIf="!showCrud && !isLoading && dataSource?.filteredData.length != 0; else nodatatemplate" class="px-5">
    <div>
        <header class="row">
            <div class="col-12 d-flex justify-content-between">
              <h2>Etapas por aprobar para pasar a fabricación</h2>
            </div>
          </header>
      <mat-table #table [dataSource]="dataSource" matSort class="mobile-table">
        <!-- Responsive Table -->
        <ng-container [matColumnDef]="column.display" *ngFor="let column of displayedColumns">
            <mat-header-cell *matHeaderCellDef mat-sort-header="{{column.property}}" [disabled]="column.display=='Acciones'"> {{column.display}} </mat-header-cell>
            <mat-cell *matCellDef="let element" class="row p-0 m-0 g-0">
                <span class="col-12 mobile-label"> {{column.display}}:</span>
                <span class="col-12" style="border-radius: 5px;" *ngIf="column.display != 'Acciones'  && column.display != 'Código'; else actionsTemplate"
                  [ngClass]="{'bg-warning': element['isPartialSave'] && column.display == 'Estatus'}"
                  [ngStyle]="{'background-color': getBackgroundColor(column.display, element), 'color': getColor(column.display, element) }"
                >
                {{ column.property == "statusDescriptionEcommerce" && element['isPartialSave'] ? 'Caso incompleto' : element[column.property] | dynamic:column.pipe}}
                </span>
                <span  *ngIf="column.property == 'code' && column.display != 'Acciones'">
                  <a href="/ecommerce/mis-casos/detail/{{element.id}}">
                    {{  element[column.property] | dynamic:column.pipe}}
                  </a>
                </span>
                <ng-template #actionsTemplate>
                  <ng-container *ngIf="column.display === 'Producto'">
                    <span *ngIf="element[column.property]!=''; else noProductTemplate">{{element[column.property] | dynamic:column.pipe}}</span>
                    <ng-template #noProductTemplate>
                      <span><mat-icon class="material-icons-outlined" style="color: red !important; font-size: 14px !important; width:16px; height:14px !important;">
                        priority_high
                        </mat-icon> <span class="ms-1">Producto o pago pendiente</span></span>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="column.display == 'Acciones'">
                    <div *ngIf="isPendingToApprove(element)">
                        <button mat-button class="button secondary-button lh-1 p-1 rounded" style="height: fit-content;" (click)="onHandleReviewStage(element)">
                          Revisar<mat-icon class="mat-icon-sm">priority_high</mat-icon>
                        </button>
                      </div>
                  </ng-container>
                  <ng-container *ngIf="column.display == 'Alineadores comprados'">
                    <span *ngIf="element['productHasUnlimtedAligners']">---</span>
                    <span *ngIf="!element['productHasUnlimtedAligners']">{{element[column.property] | dynamic:column.pipe}}</span>
                  </ng-container>
                </ng-template>

                <div class="">
                  <ng-container *ngIf="column.display == 'Link de setup'">
                    <div *ngIf="isPendingToApprove(element) && element.setupLink!='Sin link'">
                      <button mat-button class="button secondary-button lh-1 p-1 rounded" style="height: fit-content;" (click)="goToSetupLink(element)">
                        <mat-icon class="mat-icon-sm">link</mat-icon>
                      </button>
                    </div>
                  </ng-container>
                </div>
                
               
            </mat-cell>

        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay;" ></mat-row>
      </mat-table>
      <mat-paginator #paginator [length]="totalRows"
                    [showFirstLastButtons]="true"
                    [pageSize]="10"
                    [pageSizeOptions]="[5, 10, 25, 100]"
                    (page)="getAll(true)">
      </mat-paginator>
    </div>

    <div *ngIf="isLoading">
      <app-loading></app-loading>
      <h1>Obteniendo recursos...</h1>
    </div>
</div>
<ng-template #nodatatemplate >
  <div class="text-center fs-4">
    <!--Ecommerce-->
    <p>En esta página aparecerán las etapas de los casos en estatus "Por aprobar por Dr.".</p>
    <p>Si desea, puede usar el menú superior para navegar en el sitio.</p>
  </div>
  
</ng-template>
  <app-dialog #approvalDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" width="70%">
    <div>
      <div *ngIf="!isShowApprovalMessage && shippingAddressSelectionProcess == 1" class="w-75 mx-auto d-flex flex-column justify-content-center gap-2 p-4">
        <h2 class="fw-semibold text-center mb-4">Revisar propuesta</h2>
        <h6>Alineadores necesarios para esta etapa</h6>
        <div class="d-flex">
          <p class="me-2">Alineadores superiores: <strong>{{stageToApprove?.caseStageUpperAligners}}</strong></p>
          <p>Alineadores inferiores: <strong>{{stageToApprove?.caseStageLowerAligners}}</strong></p>
        </div>
        <hr>
        <h6>Alineadores fabricados del caso</h6>
        <div class="d-flex">
          <p class="me-2">Superiores: <strong>{{fabricatedUpperAligners}} de {{case?.upperAligners}}</strong></p>
          <p>Inferiores: <strong>{{fabricatedLowerAligners}} de {{case?.lowerAligners}}</strong></p>
        </div>
        <hr>
        <h6>Mecánicas Setup</h6>
        <mat-form-field class="w-100" appearance="outline">
          <textarea disabled matInput placeholder="Descripción del tipo de cliente" name="description" id="description" style="height: 120px;">{{stageToApprove?.setupMechanics}}</textarea>
        </mat-form-field>
        <mat-checkbox style="width: fit-content;" class="col text-start"  (change)="onCheckboxChange($event.checked)" [(ngModel)]="isApproveChecked" *ngIf="hasSetupMechanics"><span style="white-space:normal;" >Estoy de acuerdo con las mecánicas sugeridas por Aliwell</span></mat-checkbox>

        <div class="d-flex justify-content-between">
          <button mat-button class="button btn btn-danger lh-1 p-2 rounded mb-2"  appDebounceClick (debounceClick)="onCancelStage()" [debounceTime]="700" [disabled]="!disableAcceptSetup && hasSetupMechanics">Cancelar etapa <mat-icon>close</mat-icon></button>
          <button mat-button class="button btn-outline-primary lh-1 p-2 rounded mb-2"  appDebounceClick (debounceClick)="onSuggestAlignersByAliwell()" [debounceTime]="700" [disabled]="!disableAcceptSetup && hasSetupMechanics">Solicitar cambios <mat-icon>cached</mat-icon></button>
          <button mat-button class="button btn btn-bg-primary lh-1 p-2 rounded mb-2" style="font-size: .8rem;"  appDebounceClick (debounceClick)="onRefuseSetup()" [debounceTime]="700" [disabled]="disableAcceptSetup" style="font-size: .8rem;">Aprobar con otra cantidad de alineadores<mat-icon>edit</mat-icon></button>
          <button mat-button class="button secondary-button lh-1 p-2 rounded mb-2" (click)="goToShippingAddressSelection(false)" [disabled]="disableAcceptSetup">Autorizar propuesta <mat-icon>check</mat-icon></button>
        </div>
        <p>Nota: Antes de realizar cualquier acción revisa tu etapa y la cantidad de alineadores superiores e inferiores para la misma.</p>
      </div>
  
      <div *ngIf="isShowApprovalMessage && shippingAddressSelectionProcess == 1" class="w-50 mx-auto d-flex flex-column justify-content-center gap-2 p-4">  
        <h2 class="col text-center">Sugiere una cantidad de alineadores para esta etapa</h2>
        <mat-card class="card-general">
          <mat-card-title>Alineadores de la etapa</mat-card-title>
          <mat-card-content class="d-flex flex-column gap-4 w-100">
            <form #alignersForm="ngForm">
              <div class="row">
                <div class="col-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Alineadores Superiores</mat-label>
                    <input matInput type="number" min="0" required ngModel name="upperAligners" placeholder="Número de alineadores" [disabled]="disableEditAligners">
                    <mat-error *ngIf="alignersForm.form.hasError('required', ['upperAligners'])">Completa este campo</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Alineadores Inferiores</mat-label>
                    <input matInput type="number" min="0" required ngModel name="lowerAligners" placeholder="Número de alineadores" [disabled]="disableEditAligners">
                    <mat-error *ngIf="alignersForm.form.hasError('required', ['lowerAligners'])">Completa este campo</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-12">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Comentarios</mat-label>
                    <textarea matInput placeholder="Comentarios" name="comments" id="comments" ngModel style="height: 120px;" [disabled]="disableEditAligners"></textarea>
                  </mat-form-field>
                </div>
                <ng-container *ngIf="disableEditAligners">
                  <div class="col-12" >
                      <p><b>Para esta etapa se deben fabricar todos los alineadores restantes</b></p>
                    </div>
                </ng-container>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
  
        <div class="d-flex justify-content-center gap-4">
          <button mat-button class="btn btn-secondary" (click)="onBackToMainPage()"><mat-icon>chevron_left</mat-icon>Volver</button>
          <button mat-button class="btn btn-secondary" (click)="onUpdateAligners()" [disabled]="disableEditAligners">Enviar<mat-icon>send</mat-icon></button>
        </div>
      </div>

      <!--Address containers-->
      <div *ngIf="shippingAddressSelectionProcess == 2" class=" w-75 m-auto">
        <h2 class="fw-semibold text-center mb-4">Direcciones de Envío</h2>
        <div class="my-2" *ngIf="selectedAddress != null;else addAddressTemplate">
          <mat-card appearance="outlined" class="card-shipping-address">
            <mat-card-content class="d-flex flex-wrap justify-content-between">
              <div>
                <h6 class="fw-semibold d-flex"><div *ngIf="!selectedAddress.isAddressException">Enviar a <sup>&nbsp;</sup></div> {{selectedAddress.type}}</h6>
                <p>{{selectedAddress.fullAddress}}</p>
              </div>
              <div class="d-flex mt-auto">
                <button mat-button class="button secondary-button lh-1 p-2 rounded mb-2 mt-auto" (click)="onShippingAddressChange()">Cambiar</button>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <ng-template #addAddressTemplate>
          <p>Para avanzar es necesario seleccionar una dirección de envío</p>
          <button mat-button class="button btn btn-bg-primary lh-1 p-2 rounded mb-2 ms-auto" (click)="onGoToCustomerProfileConfirmation()">Agregar dirección <mat-icon>add</mat-icon></button>
        </ng-template>
        <p>Nota: Es necesario elegir una dirección de envío para aprobar el caso. Esta dirección podrá modificarse solamente dentro de las siguentes {{maxHoursToUpdateDate}} horas.</p>
        <div class="d-flex my-4">
          <img class="w-50 mx-auto img-fluid" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw_notify_danger.svg" alt="Notificación imagen danger">
        </div>
        <div class="d-flex justify-content-center gap-4 my-4">
          <button mat-button class="btn btn-secondary" (click)="onCancelAddressAssign()">Cancelar</button>
          <button mat-button class="btn secondary-button text-white" (click)="onConfirmSetup()" *ngIf="selectedAddress != null">Confirmar <mat-icon>send</mat-icon></button>
        </div>
      </div>
      <div *ngIf="shippingAddressSelectionProcess == 3" class="w-75 m-auto d-flex flex-column">
        <h2 class="fw-semibold text-center mb-4">Direcciones de Envío</h2>
        <div class="my-2">
          <mat-radio-group [value]="selectedAddress" (change)="onSelectionChange($event)">
            <div *ngFor="let address of addressList">
              <mat-card appearance="outlined" class="card-shipping-address mb-3">
                <mat-card-content class="d-flex flex-wrap justify-content-between">
                  <div class="d-flex">
                    <div class="d-flex my-auto">
                      <mat-radio-button value="auto" class="my-auto" [checked]="address.fullAddress == selectedAddress.fullAddress" [value]="address"></mat-radio-button>
                    </div>
                    <div>
                      <h6 class="fw-semibold d-flex"><div *ngIf="!address.isAddressException">Enviar a <sup>&nbsp;</sup></div> {{address.type}} <div class="badge badge-pickup-primary" *ngIf="address.isAddressException">Recolección</div></h6>
                      <p>{{address.fullAddress}}</p>
                    </div>
                  </div>
                  
                  <div class="d-flex mt-auto">
                    <button mat-button class="button secondary-button lh-1 p-2 rounded mb-2 mt-auto" (click)="onGoToCustomerProfileConfirmation()" *ngIf="!address.isAddressException">Editar</button>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-radio-group>
        </div>
        <button mat-button class="button btn btn-bg-primary lh-1 p-2 rounded mb-2 ms-auto" (click)="onGoToCustomerProfileConfirmation()">Agregar dirección <mat-icon>add</mat-icon></button>
        <div class="d-flex justify-content-center gap-4 my-4">
          <button mat-button class="btn btn-secondary" (click)="onCancelAddressSelection2()">Cancelar</button>
          <button mat-button class="btn secondary-button text-white" (click)="goToShippingAddressSelection(this.isApproveWithChanges)">Seleccionar <mat-icon>check</mat-icon></button>
        </div>
      </div>
      <div *ngIf="shippingAddressSelectionProcess == 4" class="w-75 m-auto d-flex flex-column">
        <h2 class="text-center mb-4">Serás redirigido a tu perfil para realizar los cambios de dirección y deberás reiniciar el proceso de aprobación</h2>
        <h2 class="fw-semibold text-center mb-4">¿Deseas confirmar?</h2>
        <div class="d-flex my-4">
          <img class="w-50 mx-auto img-fluid" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw_notify_danger.svg" alt="Notificación imagen danger">
        </div>
        <div class="d-flex justify-content-center gap-4 my-4">
          <button mat-button class="btn btn-secondary" (click)="onCancelAddressEdition()">Cancelar</button>
          <button mat-button class="btn btn-danger text-white" (click)="onGoToCustomerProfile()">Continuar <mat-icon>arrow_forward</mat-icon></button>
        </div>
      </div>
    </div>
  </app-dialog>

  <app-dialog #deleteDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onDeleteCaseStage.bind(this)" confirmButtonText="Eliminar" confirmButtonIcon="block" confirmButtonClass="button danger-button" height="90%" width="90%">
    <div>
      <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
        <div *ngIf="stageToApprove?.stageCount == 1;else firstStageTemplate">
          <h2 class="col text-center"><strong>Estás a punto de cancelar</strong> la etapa #<strong>{{stageToApprove?.stageCount ?? "Etapa seleccionada"}}</strong>, Al ser la etapa #1 toda la información del paciente incluyendo la prescripción se perderá y no se puede deshacer este cambio. <strong>¿Estás seguro que deseas cancelar ésta etapa? </strong></h2>
        </div>
        <ng-template #firstStageTemplate>
          <h2 class="col text-center"><strong>Estás a punto de cancelar</strong> la etapa #<strong>{{stageToApprove?.stageCount ?? "Etapa seleccionada"}}</strong>, La información de la prescripción se perderá y no se puede deshacer este cambio. <strong>¿Estás seguro que deseas cancelar ésta etapa? </strong></h2>
        </ng-template>
        <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw_notify_danger.svg" alt="Notificación imagen danger">
      </div>
    </div>
  </app-dialog>

  <app-dialog #suggestAlignersByAliwellDialog [enableCloseDialogButton]="true" cancelButtonText="Volver" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onAddComments.bind(this)" confirmButtonText="Enviar" confirmButtonClass="btn btn-secondary" height="90%" width="90%">
    <div>
      <div class="w-75 mx-auto d-flex flex-column p-2">
        <h2 class="col text-center">Solicitar cambios y/o correciones al setup</h2>
        <mat-radio-group class="w-100" (ngModelChange)="onSetupCorrectionSelectionChange()"  [(ngModel)]="selectedSetupCorrection">
          <div *ngFor="let option of setupCorrectionsOptions;let i = index" >
            <mat-card class="setup-change-option-card w-100 h-100 mt-2 p-2" >
              <mat-radio-button [value]="option.value" [checked]="option.value == selectedSetupCorrection">
                <h4>{{option.label}}</h4>
              </mat-radio-button>
              <mat-card-content class="d-flex flex-column w-100 h-100">
                <div class="d- flex" *ngIf="option.value == 3">
                  <mat-icon style="color: #0D565E;">info</mat-icon><b>Importante: </b> No es posible conseguir el mismo resultado con menos alineadores.
                </div>
                <mat-form-field class="w-100 h-100 p-0 m-0 setup-textarea" appearance="outline" color="primary">
                  <textarea matInput [disabled]="option.value != selectedSetupCorrection" placeholder={{option.description}} [(ngModel)]="correctionValues[i]"></textarea>
                </mat-form-field>
              </mat-card-content>
            </mat-card>
          </div>
         
        </mat-radio-group>
      </div>
    </div>
  </app-dialog>



